import { patch } from "../helpers/api_helper"

export const fiscalFields = [
  "legalName",
  "legalForm",
  "ice",
  "fiscalIdentifier",
  "commercialRegisterNumber",
  "professionalTaxNumber",
  "cnssNumber",
]

export const getStoreFiscalPayload = values =>
  fiscalFields.reduce((payload, field) => {
    payload[field] = values[field]?.trim() || null
    return payload
  }, {})

export const updateStoreFiscalInformation = (store, values) => {
  const storeId = store?.id
  if (!storeId) throw new Error("L’identifiant du commerce est introuvable.")

  return patch(`stores/${storeId}`, getStoreFiscalPayload(values), {
    headers: {
      "Content-Type": "application/merge-patch+json",
      Accept: "application/ld+json",
    },
  })
}
